import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const browseIssueEmbedRoute: InvariantJiraRoute = {
	name: 'issue-embed',
	path: '/browse/:issueKey(\\w+-\\d+)/embed',
};
